import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const GameControls = ({ onChoice, disabled, isProcessing, gamePhase, playerRole }) => {
  const numbers = [0, 1, 2, 3, 4, 5, 6];

  return (
    <div className="game-controls-container w-full">
      <div className="grid grid-cols-4 md:grid-cols-7 gap-3 md:gap-4 max-w-4xl mx-auto">
        {numbers?.map((num) => (
          <Button
            key={num}
            variant="default"
            size="lg"
            onClick={() => onChoice(num)}
            disabled={disabled || isProcessing}
            loading={isProcessing && num === 0}
            className="h-20 md:h-24 text-2xl md:text-3xl font-heading font-bold shadow-glow-cyan-lg hover:shadow-glow-cyan-md transition-all duration-base hover:scale-105 active:scale-95 active:shadow-glow-magenta-md"
          >
            {num}
          </Button>
        ))}
      </div>
      <div className="mt-6 md:mt-8 text-center space-y-2">
        <p className="text-xs md:text-sm font-caption text-muted-foreground tracking-wide">
          {playerRole === 'batting' && (
            <>
              <Icon name="Target" size={16} className="inline mr-2" />
              BATTING: CHOOSE YOUR NUMBER TO SCORE RUNS
            </>
          )}
          {playerRole === 'bowling' && (
            <>
              <Icon name="Crosshair" size={16} className="inline mr-2" />
              BOWLING: PREDICT AI'S NUMBER TO GET THEM OUT
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default GameControls;